import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
/**
 * Error boundary component to catch and handle React errors
 * Prevents the entire app from crashing when a component throws an error
 */ export class ErrorBoundary extends Component {
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
        this.props.onError?.(error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col items-center justify-center p-6 text-center",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "text-lg font-semibold text-destructive mb-2",
                        children: "Something went wrong"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-sm text-muted-foreground mb-4",
                        children: this.state.error?.message || 'An unexpected error occurred'
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        onClick: ()=>this.setState({
                                hasError: false,
                                error: null
                            }),
                        className: "px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90",
                        children: "Try again"
                    })
                ]
            });
        }
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            error: null
        };
    }
}
